<template>
  <div id="con1" class="conBox" :class="menuBtn">
    <info-box
      v-if="isLocationInfo"
      :center-location="statusDetail.abc_name"
      :cfm-kind="statusDetail.cfm_kind"
      @on-reservation-info="onReservationInfo"
    />
    <state-detail
      :applied-status-detail="statusDetail"
      :products-details="productsDetails"
      :disabled-pack-name="disabledPackName"
      @change-packname="$emit('change-packname')"
    />
    <div class="cont_section">
      <mpn-section-title>제품정보</mpn-section-title>
      <products-detail :products-by-group="productsByGroup" />
    </div>
    <mypack-detail-btn-group
      ref="refBtnGroup"
      :button-states="buttonStates"
      :req-no="statusDetail.req_no"
      :purchase-type="statusDetail.purchase_type"
      @on-order="$emit('on-order')"
      @on-cancel-order="$emit('on-cancel-order')"
      @on-reorder="$emit('on-reorder')"
      @item-state-change="$emit('item-state-change')"
    />
    <modal-alert ref="refAlert" />
    <modal-reservation ref="refModal" />
  </div>
</template>

<script>
import { PACK_STATUS_CODE, ORDER_STATUS_CODE } from "@/utils/constants";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ReservationLink from "@/components/ReservationLink.vue";
import ModalReservation from "@/components/modal-popups/ModalReservation.vue";
import StateDetail from "./recent-part/StateDetail.vue";
import ProductsDetail from "./recent-part/ProductsDetail.vue";
import InfoBox from "./recent-part/InfoBox.vue";
import MypackDetailBtnGroup from "./recent-part/MypackDetailBtnGroup.vue";
import MypacksItemBtnGroup from "../../main/partial/MypacksItemBtnGroup.vue";
import ModalReorderRequest from "@/components/modal-popups/ModalReorderRequest.vue";
import ModalUnavailableProducts from "@/components/modal-popups/ModalUnavailableProducts.vue";

export default {
  name: "RecentOrderSheet",
  components: {
    StateDetail,
    ProductsDetail,
    InfoBox,
    MypackDetailBtnGroup,
    ModalAlert,
    ReservationLink,
    ModalReservation,
    MypacksItemBtnGroup,
    ModalUnavailableProducts,
    ModalReorderRequest,
  },
  props: {
    statusDetail: {
      type: Object,
      default: () => {},
    },
    productsDetails: {
      type: Array,
      default: () => [],
    },
    productsByGroup: {
      type: Array,
      default: () => [],
    },
    buttonStates: {
      type: Object,
      default: () => ({}),
    },
    menuBtn: {
      type: String,
      default: "on",
    },
    orderHistorys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      paymentFloatingBtn: false,
      btnStateName: "",
      functionName: "",
    };
  },
  computed: {
    // "상담 및 결제 완료", "마이팩 포장 시작" 인 경우 Diable
    disabledPackName() {
      if (this.orderHistorys.length > 0) {
        if (
          this.orderHistorys[0].status === ORDER_STATUS_CODE.PAYMENT_FINISHED ||
          this.orderHistorys[0].status === ORDER_STATUS_CODE.DIVISION_STARTED
        ) {
          return true;
        }
      }
      return false;
    },
    isLocationInfo() {
      // "마이팩 생성" 단계만 노출
      if (
        this.statusDetail.pack_status ===
        PACK_STATUS_CODE.CONSULTATION_REQUESTED
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onReservationInfo() {
      this.$refs.refModal.open();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/mypacks/detail/partial/RecentOrderSheet.vue